import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AppConfigService } from "./app-config.service";

@Injectable({ providedIn: 'root' })
export class CurrencyService {

  private rates: Record<string, number> = {};
  private loadedDate: string | null = null;

  constructor(private http: HttpClient) {}

  ensureRatesLoaded(): Observable<void> {
    const today = new Date().toISOString().split('T')[0];
    if (this.loadedDate === today && Object.keys(this.rates).length > 0) {
      return of(undefined);
    }
    return this.http.get<Record<string, number>>(AppConfigService.productMangementUrl + '/exchange-rates/latest').pipe(
      tap((rates: Record<string, number>) => {
        this.rates = rates;
        this.loadedDate = today;
      }),
      map(() => undefined as void)
    );
  }

  convert(amount: number, fromCurrency: string, toCurrency: string): number {
    if (!amount || !fromCurrency || !toCurrency) return amount ?? 0;
    if (fromCurrency === toCurrency) return amount;
    if (Object.keys(this.rates).length === 0) return amount;
    const fromRate = this.rates[fromCurrency.toUpperCase()] ?? 1;
    const toRate   = this.rates[toCurrency.toUpperCase()] ?? 1;
    return (amount / fromRate) * toRate;
  }

  getRates(): Record<string, number> {
    return this.rates;
  }
}